import React from "react";
import { Button } from "../components/Button";
import { Gallery } from "../components/Gallery";
import { Timeline } from "../components/Timeline";
import { Data } from "../constants/data";

interface Props {
  data: Data;
}

export const ProductPage: React.FC<Props> = ({ data }) => {
  return (
    <div className="max-w-screen-lg mx-auto select-none">
      <div className="flex flex-col items-center justify-center h-full gap-8 pb-8 lg:flex-row lg:h-2/3">
        <div className="w-full h-full lg:w-2/3" style={{ height: 600 }}>
          {data.model}
        </div>

        <div className="flex flex-col items-start shrink-0 w-full gap-2 px-4 lg:w-1/3 lg:px-0">
          <h1 className="text-6xl font-black tracking-wider font-title">
            {data.title}
          </h1>
          <p className="font-sans max-h-72 overflow-auto mt-4">
            {data.description.long}
          </p>
          <div className="mt-6 flex gap-2">
            <Button
              href={data.externalUrl}
              label={data.externalUrl ? "Find Out More" : "Sold Out"}
            />
            {data.page?.button}
          </div>
        </div>
      </div>

      <div className="px-4 sm:px-0 pb-8">{data.page?.content}</div>

      <Gallery data={data} />
      {data.timeline.length ? <Timeline data={data} /> : null}
    </div>
  );
};
